import createPersistedState from 'vuex-persistedstate';

import userData from './modules/userData'
import company from './modules/company'
import filterOptions from './modules/filterOptions'
import alert from './modules/alert'

//initiliase store for Vuex
const store  = {
  plugins: [
    createPersistedState({})
  ],
    state : {
      filterUrl : '',
      updateData : 0
    },
    modules : {
        userData,
        company,
        filterOptions,
        alert
    }
};

export default store;